import React, { useState, useEffect, useCallback, useContext } from 'react';
import SegmentedButton from './SegmentedButton';
import ModeControl from './ModeControl';
import CurrentActivity from './CurrentActivity';
import TemperatureSelector from './TemperatureSelector';
import TemperatureGauge from './TemperatureGauge';
import Graph from './Graph';
import RoomContext from '../RoomContext';
import { useRoomApi } from '../hooks/useRoomApi';
import './MainTab.css';
import './Label.css';

// Polls the composite /status once and drives every control from it. Mutations run, then refresh.
const MainTab = () => {
  const { tenant, room } = useContext(RoomContext);
  const api = useRoomApi(tenant, room);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      setStatus(await api.getStatus());
      setError(null);
    } catch (e) {
      setError('No se pudo conectar con el servidor.');
    }
  }, [api]);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 10000);
    return () => clearInterval(id);
  }, [refresh]);

  const act = async (fn) => {
    try { await fn(); } catch (e) { console.error('action failed', e); }
    await refresh();
  };

  if (error && !status) return <div className="alert alert-danger m-3">{error}</div>;
  if (!status) return <div className="p-3">Cargando…</div>;

  const { mode } = status;

  return (
    <div className="main-tab-container pt-3">
      <ModeControl mode={mode} onSelect={(m) => act(() => api.setMode(m))} />
      <CurrentActivity activity={status.currentActivity} />

      <div className="row mt-3 mb-0 mx-0">
        <div className="col"><span className="label control-label">Temperatura Actual</span></div>
        <div className="col"><span className="label control-label">Temperatura Deseada</span></div>
      </div>
      <div className="row mb-2 mx-0 align-items-center">
        <div className="col"><TemperatureGauge value={status.temperature} /></div>
        <div className="col">
          <TemperatureSelector
            value={status.desiredTemperature}
            dimmed={mode !== 'Active'}
            onChange={(t) => act(() => api.setDesiredTemperature(t))}
          />
        </div>
      </div>

      <div className="mt-2">
        <span className="label button-label">Calefactor</span>
        <SegmentedButton
          position={status.position}
          dimmed={mode !== 'Manual'}
          onSelect={(p) => act(() => api.setPosition(p))}
        />
      </div>

      <Graph />
    </div>
  );
};

export default MainTab;
